import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportFuelConsumptionByDeviceLazy
} from "@containers/reports/readyReports/reportFuelConsumption/ReportFuelConsumptionByDevice.lazy";


const ReportFuelConsumptionByDevicePage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >

                <ReportFuelConsumptionByDeviceLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportFuelConsumptionByDevicePage;